module.exports = __webpack_public_path__ + "img/gaijuan.cbdc1227.png";